import { FilterDrawerContainerProps } from '@msc-b2c/interfaces/types';
import { useSelector, useDispatch } from 'react-redux';
import {
  AppDispatch,
  RootState,
  syncAppliedToFiltered,
  toggleDisplayOverlay,
  triggerFilterApplication,
  triggerFilterClearing,
  triggerOpenFilterDrawer,
} from '@msc-b2c/shared-utils';
import React, { ReactNode, useEffect } from 'react';
import { triggerPAFiltersEvent } from '../utils/myAreaAnalytics';
import { Drawer } from '../drawer/Drawer';

export function FilterDrawerContainerWrapper({
  filterModalTitle,
  filterModalClearButton,
  filterModalApplyButton,
  children,
}: Readonly<FilterDrawerContainerProps>) {
  const dispatch = useDispatch<AppDispatch>();
  const isDrawerOpen = useSelector((state: RootState) => state.myAreaFilter.showFilterDrawer);
  const selectedDay = useSelector((state: RootState) => state.myCruise.selectedDayFilter);
  const filtersApplied = useSelector(
    (state: RootState) => state.myAreaFilter.categoryFilters?.applied
  );

  const filterChildren: ReactNode[] | undefined = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return null;
    return child?.props?.children;
  })?.filter((child: ReactNode) => child !== null);

  useEffect(() => {
    dispatch(triggerFilterClearing());
    dispatch(triggerFilterApplication());
  }, [selectedDay]);

  useEffect(() => {
    if (filtersApplied?.length > 0) {
      // create a string with all the filter type of the applied filters separated by a semicolon
      const filtersString = filtersApplied?.map((filter) => filter.filterType).join('; ');
      triggerPAFiltersEvent(filtersString);
    }
  }, [filtersApplied]);

  return (
    <Drawer
      title={filterModalTitle}
      firstButtonLabel={filterModalApplyButton}
      secondButtonLabel={filterModalClearButton}
      isDrawerOpen={isDrawerOpen}
      onClose={() => {
        dispatch(triggerOpenFilterDrawer(false));
        //syncAppliedToFiltered ensures that it show the real data on the filter after closing it
        dispatch(syncAppliedToFiltered());
        toggleDisplayOverlay();
      }}
      onApply={() => {
        dispatch(triggerFilterApplication());
        toggleDisplayOverlay();
      }}
      onClear={() => {
        dispatch(triggerFilterClearing());
      }}
      enableClosingByClickingOutside={true}
      stylingOption="default"
    >
      {filterChildren}
    </Drawer>
  );
}

export default FilterDrawerContainerWrapper;

FilterDrawerContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/filterdrawercontainer';
